<div class="header">
    <img src="https://fodimi.pl/img/site_logo/logo_4.png">
</div>
<ng-container  *ngIf="!formSent">
    <div class="content-container form-elem" [formGroup]="form">
        <h3>Podaj nam dane klienta, abyśmy mogli się z nim skontaktować i przedstawić naszą ofertę</h3>
        <div class="form mt-3">
            <div class="form-floating mb-3">
                <div class="form-floating mb-1">
                    <input class="form-control" type="number" formControlName="partnerTaxId" [ngClass]="{ 'is-invalid':submitted && !form.get('partnerTaxId').valid}">
                    <label>NIP firmy polecającej (partnera)</label>
                </div>
            </div>
            <div class="form-floating mb-3">
                <div class="form-floating mb-1">
                    <input class="form-control" formControlName="restaurantName" [ngClass]="{ 'is-invalid':submitted && !form.get('restaurantName').valid}">
                    <label>Nazwa restauracji</label>
                </div>
            </div>
            <div class="form-floating mb-3">
                <div class="form-floating mb-1">
                    <input class="form-control" formControlName="name" [ngClass]="{ 'is-invalid':submitted && !form.get('name').valid}">
                    <label>Imię osoby do kontaktu</label>
                </div>
            </div>
            <div class="form-floating mb-3">
                <div class="form-floating mb-1">
                    <input class="form-control" type="number" formControlName="taxId" [ngClass]="{ 'is-invalid':submitted && !form.get('taxId').valid}">
                    <label>NIP firmy</label>
                </div>
            </div>
            <div class="form-floating mb-3">
                <div class="form-floating mb-1">
                    <input class="form-control"   formControlName="phone"  [ngClass]="{ 'is-invalid':submitted && !form.get('phone').valid}">
                    <label>Numer telefonu</label>
                </div>
            </div>
            <div class="form-floating mb-3">
                <div class="form-floating mb-1">
                    <input class="form-control" formControlName="email"  [ngClass]="{ 'is-invalid':submitted && !form.get('email').valid}">
                    <label>E-mail</label>
                </div>
            </div>
            <div class="form-floating mb-3">
                <div class="form-floating mb-1">
                    <textarea class="form-control" formControlName="comment"  [ngClass]="{ 'is-invalid':submitted && !form.get('comment').valid}"></textarea>
                    <label>Co klient potrzebuje, czy był już z nim pierwszy kontakt, czy klient wie, że będziemy dzwonić itd.</label>
                </div>
            </div>

        </div>
        <div class="text-center">
            <button class="btn btn-primary" (click)="save()" [disabled]="!form.valid">Prześlij dane</button>
            <a  href="https://fodimi.pl"><button class="ml-2 btn btn-outline-primary">Wróć na stronę główną</button></a>
        </div>
    </div>
</ng-container>
<ng-container  *ngIf="formSent">
    <div class="content-container">
        <img src="assets/img/done.svg" width="100">
        <h4 class="mb-4 mt-4">Dziękujemy za wypełnienie formularza! Wkrótce pojawi się on na Twojej liście leadów</h4>
        <div class="text-center">
            <a  href="https://fodimi.pl"><button class="btn btn-primary">Wróć na stronę główną</button></a>
        </div>
    </div>

</ng-container>
